import React from "react";
import Menu from "./../../components/Base/IconMenuComponent";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch } from "react-redux";
import { authActions } from "../../store/auth";
const SmallScreenMenus = ({ isLoggedIn, navigate, NAV_LINKS }) => {
  const dispatch = useDispatch();
  const menuOptions = [
    ...NAV_LINKS.map((eachNav) => {
      return {
        id: eachNav.name,
        label: eachNav.label,
        handleClick: () => {
          navigate(eachNav.route);
        },
      };
    }),
    ...(isLoggedIn
      ? [
          {
            id: "my-account",
            label: "My Account",
            handleClick: () => navigate("/home"),
          },
          {
            id: "logout",
            label: "Logout",
            handleClick: () => dispatch(authActions.logout()),
            props: {
              sx: {
                color: "secondary.main",
              },
            },
          },
        ]
      : [
          {
            id: "login",
            label: "Login",
            handleClick: () => navigate("/login"),
          },
          {
            id: "register",
            label: "Sign Up",
            handleClick: () => navigate("/register"),
            props: {
              sx: {
                backgroundColor: "primary.main",
                borderRadius: "10px",
              },
            },
          },
        ]),
  ];
  return (
    <div>
      <Menu options={menuOptions} icon={<MenuIcon />} isIcon />
    </div>
  );
};

export default SmallScreenMenus;
